<div class="navbarContainer">
  <div class="navbar">
    <app-merchant-logo *ngIf="itsValidToken && itsValidImg" [user]="user"></app-merchant-logo>
    <app-secure></app-secure>
  </div>
</div>
